import React from 'react';
import { Line } from 'Components/frameworks/line/Line';

const SectionLine = (props: any) => <Line props={props} />;

export default SectionLine;
